import type { Banner, BannerBlock } from '@/types'

import { getFileUrl, prepareImagePathTemplates } from '@/helpers'

import { BANNER_TEMPLATES_BY_COUNT } from '@/constants'

export function getBannersCount(block: Partial<BannerBlock>) {
  return parseInt((block?.type ?? '').split('_')[1]) as 1 | 2 | 3 | 4
}

export function getBanner(block: BannerBlock, index: number) {
  return block.parameters.banners[index]
}

export function getBannerMediaPath(
  block: BannerBlock,
  index: number
): { src: string; srcSet?: string[] } {
  const mediaPath = getBanner(block, index).image
  if (typeof mediaPath !== 'string') return { src: '' }

  if (isVideo(mediaPath)) return { src: getFileUrl(`original/${mediaPath}`) }

  const count = getBannersCount(block)

  return {
    srcSet: prepareImagePathTemplates(
      BANNER_TEMPLATES_BY_COUNT[count],
      mediaPath
    ),
    src: getFileUrl(`${BANNER_TEMPLATES_BY_COUNT[count][0][0]}/${mediaPath}`),
  }
}

export function getBannerField(
  block: BannerBlock,
  index: number,
  key: keyof Banner,
  def = ''
) {
  return getBanner(block, index)?.[key] ?? def
}

export function isVideo(mediaPath: string) {
  return (
    mediaPath.includes('video/mp4') ||
    mediaPath.includes('.mp4') ||
    mediaPath.includes('.webm') ||
    mediaPath.includes('.mov')
  )
}
